import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
    selector: 'ngx-dino-component',
    templateUrl: './dropdown-component.component.html',
    styleUrls: ['./dropdown-component.component.scss'],
    standalone: false
})
export class DropdownComponentComponent {
  @Input() clientList: any[] = [];
  /**
   * Holds the currently selected items.
   * You can also set a default selection from the parent.
   */
  @Input() selectedClients: any[] = [];

  /**
   * Emits the entire array of selected items whenever it changes.
   * Parent can listen to this event for updates.
   */
  @Output() selectionChange = new EventEmitter<any[]>();

  /** The list displayed in the dropdown after filtering. */
  filteredOptions: any[] = [];

  /** The text typed into the search box. */
  searchTerm: string = '';

  /** Controls the visibility of the dropdown menu. */
  dropdownVisible: boolean = false;

  ngOnInit() {
    // Initialize with full client list
    this.filteredOptions = [...this.clientList];
  }

  /**
   * Filters clients by name, surname, role, or company.
   */
  filterOptions() {
    if (this.searchTerm.trim()) {
      const lowerSearch = this.searchTerm.toLowerCase();
      this.filteredOptions = this.clientList.filter(client => {
        const name = client.name?.toLowerCase() || '';
        const surname = client.surname?.toLowerCase() || '';
        const role = client.role?.toLowerCase() || '';
        const company = client.company?.toLowerCase() || '';
        return (
          name.includes(lowerSearch) ||
          surname.includes(lowerSearch) ||
          role.includes(lowerSearch) ||
          company.includes(lowerSearch)
        );
      });
    } else {
      // If no search term, show all
      this.filteredOptions = [...this.clientList];
    }
  }

  /**
   * Shows the dropdown menu.
   */
  showDropdown() {
    this.dropdownVisible = true;
  }

  /**
   * Hides the dropdown menu with a small delay,
   * so that click events inside the dropdown can register first.
   */
  hideDropdown() {
    setTimeout(() => {
      this.dropdownVisible = false;
    }, 200);
  }

  /**
   * Toggles selection of a client in the selectedClients array.
   * If it's already selected, remove it; otherwise, add it.
   */
  toggleSelection(client: any, event?: MouseEvent) {
    // Prevent the click from closing the dropdown if needed
    if (event) {
      event.stopPropagation();
    }

    const index = this.selectedClients.findIndex(c => c.id === client.id);
    if (index > -1) {
      this.selectedClients.splice(index, 1);
    } else {
      this.selectedClients.push(client);
    }

    // Emit the updated list of selected clients
    this.selectionChange.emit(this.selectedClients);
  }

  /**
   * Checks if a client is already selected.
   */
  isSelected(client: any): boolean {
    return this.selectedClients.some(c => c.id === client.id);
  }

  /**
   * Detects clicks outside the dropdown.
   * If the click target is outside, we hide the dropdown.
   */
  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const dropdownElement = document.querySelector('.dropdown') as HTMLElement;
    if (dropdownElement && !dropdownElement.contains(target)) {
      this.hideDropdown();
    }
  }
}
